interface ICrewMemberNameProps {
  crewMemberName: string;
  type: "firstname" | "lastname";
  size: number;
}

/**
 * Separate component to allow for resizing and use of SizeMe callback
 * @param props - crewMemberFirstName, nameFontSize
 */
const CrewMemberName = (props: ICrewMemberNameProps): JSX.Element => {
  const { crewMemberName, type, size } = props;
  const fontSize = crewMemberName?.length <= 10 ? "14px" : "12px";
  // const { ref } = useFitText();

  return (
    <div
      // ref={ref}
      className={`crew_${type}`}
      style={{
        fontSize, // percent of the assigned fontSize to use.
        lineHeight: fontSize === "14px" ? "15px" : "13px",
        maxHeight: 28,
        width: size,
        overflow: "hidden",
        textOverflow: "ellipsis",
        margin: type === "firstname" ? "1px 0px" : 0,
      }}
    >
      {crewMemberName}
    </div>
  );
};

export default CrewMemberName;

/* DEPRECATED dynamic font sizing hook as it wasn't working properly in all scenarios.
const useFitText = (): { fontSize: string; ref: React.MutableRefObject<HTMLDivElement> } => {
  const MIN_FONT_SIZE = 70; // 70 percent of assigned size.
  const MAX_FONT_SIZE = 100; // 100 percent of assigned size.
  const RESOLUTION = 5;

  const ref = useRef(null);

  const [state, setState] = useState({
    fontSize: MAX_FONT_SIZE,
    fontSizePrev: MIN_FONT_SIZE,
    fontSizeMax: MAX_FONT_SIZE,
    fontSizeMin: MIN_FONT_SIZE,
  });
  const { fontSize, fontSizeMax, fontSizeMin, fontSizePrev } = state;

  useEffect(() => {
    const isDone = Math.abs(fontSize - fontSizePrev) <= RESOLUTION;
    const isOverflow =
      !!ref.current &&
      (ref.current.scrollHeight > ref.current.offsetHeight || ref.current.scrollWidth > ref.current.offsetWidth);
    const isAsc = fontSize > fontSizePrev;

    // return if the font size has been adjusted "enough" (change within RESOLUTION)
    // reduce font size by one increment if it's overflowing
    if (isDone) {
      if (isOverflow) {
        const fontSizeNew = fontSizePrev < fontSize ? fontSizePrev : fontSize - (fontSizePrev - fontSize);
        setState({
          fontSize: fontSizeNew,
          fontSizeMax,
          fontSizeMin,
          fontSizePrev,
        });
      }
      return;
    }

    // binary search to adjust font size
    let delta;
    let newMax = fontSizeMax;
    let newMin = fontSizeMin;
    if (isOverflow) {
      delta = isAsc ? fontSizePrev - fontSize : fontSizeMin - fontSize;
      newMax = Math.min(fontSizeMax, fontSize);
    } else {
      delta = isAsc ? fontSizeMax - fontSize : fontSizePrev - fontSize;
      newMin = Math.max(fontSizeMin, fontSize);
    }
    setState({
      fontSize: fontSize + delta / 2,
      fontSizeMax: newMax,
      fontSizeMin: newMin,
      fontSizePrev: fontSize,
    });
  }, [fontSize, fontSizeMax, fontSizeMin, fontSizePrev, ref]);

  return { fontSize: `${fontSize}%`, ref };
};
*/
